var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('MazPhoneNumberInput',{attrs:{"size":"sm","showCodeOnList":true,"noFlags":true,"position":_vm.position,"defaultPhoneNumber":_vm.defaultPhoneNumber,"onlyCountries":_vm.onlyCountries,"ignoredCountries":_vm.ignoredCountries,"translations":{
      countrySelectorLabel: _vm.$t('phone_input_country_code'),
      countrySelectorError: _vm.$t('phone_input_country_error'),
      phoneNumberLabel: _vm.$t('phone_input_number_hint'),
      example: _vm.$t('phone_input_number_example') + ':',
    }},on:{"update":_vm.update}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }